import styled from "styled-components";

export const Year = styled.div`
    width: 80px;
    margin-right: 8px;
`;

export const Month = styled.div`
    width: 130px;
    margin-right: 8px;
`;

export const StyledFullDate = styled.div`
    display: flex;
`;

export const StyledDate = styled.div`
    flex: 1;
`;

export const StyledFullTime = styled.div`
    display: flex;
    margin-top: 8px;
`;

export const TimeText = styled.div`
    line-height: 42px;
    margin: 0 6px;
`;
